var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
export var basicAssociationFields = [
    'associationName',
    'email',
    'phone',
    'contact',
    'website',
];
export var allAssociationFields = __spreadArray(__spreadArray([], basicAssociationFields), [
    'image',
    'signedContract',
    'properManagement',
    'section46',
    'section46Expiry',
    'bankAccountHolder',
    'bankName',
    'bankBranchNumber',
    'bankAccountNumber',
]);
//# sourceMappingURL=association-fields.js.map